define('fukit/view/app.header.view',['require','exports','module','lodash','../config','uikit/uikit','../blockit.shared','backbone.radio','../helpers/route.helper','../behavior/resolve.options.behavior','../resources/commonSvgs','handlebars'],function (require, exports, module) {
    //prettier-ignore
    var lodash = require('lodash'),
        config = require('../config'),
        UIKit = require('uikit/uikit'),
        BlocKit = require('../blockit.shared'),
        Radio = require('backbone.radio'),
        RouteHelper = require('../helpers/route.helper'),
        ResolveOptionsBehavior = require('../behavior/resolve.options.behavior'),
        commonSvgs = require('../resources/commonSvgs'),
        Handlebars = require('handlebars');

    var userMenuDivider = new UIKit.Dropdown.DividerModel();

    var USER_ACTIONS = [
        userMenuDivider,
        {displayName: 'Help Center', icon: 'question', path: 'https://support.cayuse.com', target: '_blank'},
        {displayName: 'Log Out', icon: 'power', action: 'logout', hasAction: true},
    ];

    var AppHeaderView = UIKit.Menu.extend({
        className: UIKit.Menu.prototype.className + ' shared-header',
        options: lodash.extend({}, UIKit.Menu.prototype.options, {
            fixed: true,
            title: false,
        }),

        behaviors: {
            ResolveOptionsBehavior: {
                behaviorClass: ResolveOptionsBehavior,
            },
        },

        internalViewOptions: {
            appLogoView: {
                type: UIKit.Menu.Item.extend({
                    // We either show the menu button in the top left or nothing.
                    attributes: {style: 'font-weight: bold;'},
                }),
                subMenu: true,
                internalViewOptions: {
                    subMenu: function () {
                        var subMenu = {
                            type: BlocKit.ImageView,
                            className: 'header-logo',
                        };
                        var headerLogoAttributes = config.get('app.header.logo.*');
                        if (headerLogoAttributes && Object.keys(headerLogoAttributes).length > 0) {
                            subMenu.attributes = headerLogoAttributes;
                        } else {
                            subMenu.svgData = new Handlebars.SafeString(commonSvgs.genericResearchSuiteLogo);
                        }
                        return subMenu;
                    },
                },
                link: true,
                onPress: function () {
                    RouteHelper.navigate('default', {}, {trigger: true});
                },
                behaviors: {
                    BindAndFormatOptionValuesBehavior: {
                        model: config,
                        optionValues: {
                            visible: {
                                formatter: function () {
                                    return config.get('cayuse.menu.show');
                                },
                            },
                        },
                        behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                    },
                },
            },
            userDropdownView: function () {
                return {
                    type: UIKit.Dropdown,
                    className: UIKit.Dropdown.prototype.className + ' header-dropdown',
                    icon: false,
                    behaviors: {
                        BindAndFormatOptionValuesBehavior: {
                            optionValues: {
                                text: {
                                    formatter: function (model) {
                                        //prettier-ignore
                                        var fullName = model.get('fullName'),
                                            username = model.get('username');

                                        if (fullName && fullName.trim().length > 0) {
                                            displayName = fullName;
                                        } else if (username && username.length > 0) {
                                            displayName = username;
                                        } else {
                                            displayName = 'Current User';
                                        }

                                        return new Handlebars.SafeString(
                                            '<i class="icon user"></i>' +
                                            '<span class="dropdown-text">' +
                                            displayName +
                                            '</span>' +
                                            '<i class="icon dropdown"></i>'
                                        );
                                    },
                                },
                                collection: {
                                    formatter: function (model) {
                                        var actions = [
                                            {displayName: model.get('email')},
                                            {displayName: model.get('customerName') || 'Current Customer'},
                                        ].concat(USER_ACTIONS);
                                        return new Backbone.Collection(actions);
                                    },
                                },
                            },
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                        },
                        ResolveOptionsBehavior: {
                            behaviorClass: ResolveOptionsBehavior,
                        },
                    },
                    resolveOptions: {
                        model: '@resources.userPrincipalModel',
                    },
                    childViewOptions: {
                        bindings: {
                            target: 'target',
                            text: 'displayName',
                            icon: 'icon',
                            imageUrl: 'thumbnail',
                            imageAlt: 'imageAlt',
                            imageWidth: 'imageWidth',
                            imageHeight: 'imageHeight',
                            link: 'path',
                            hasAction: 'hasAction',
                        },
                    },
                    collection: new Backbone.Collection(USER_ACTIONS),
                    onBeforeRender: function (view) {
                        view.listenTo(view, 'childview:press', function (childView) {
                            var action = childView.model.get('action');
                            if (action === 'logout') {
                                Radio.channel('evicommon.authenticationService').request(action);
                            }
                        });
                    },
                };
            },
            appsDropdownView: function () {
                var activeProductCollection = Radio.request('AppKit.resourceService', 'resource', 'activeProductCollection');

                return {
                    type: UIKit.Dropdown,
                    className: UIKit.Dropdown.prototype.className + ' header-dropdown',
                    attributes: {id: 'apps-dropdown'},
                    icon: false,
                    text: new Handlebars.SafeString(
                        commonSvgs.squareCayuseIcon +
                        '<span class="dropdown-text">Products</span>' +
                        '<i class="icon dropdown"></i>'
                    ),
                    visible: config.get('cayuse.apps.switcher.visible'),
                    childViewOptions: {
                        bindings: {
                            text: 'displayName',
                            icon: 'icon',
                            imageUrl: 'thumbnail',
                            imageAlt: 'imageAlt',
                            imageWidth: 'imageWidth',
                            imageHeight: 'imageHeight',
                            link: 'path',
                        },
                        behaviors: {
                            setLegacyProductTargetBlank: {
                                behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                                optionValues: {
                                    target: {
                                        formatter: function (model) {
                                            if (model.get('isExternal')) return '_blank';
                                        },
                                    },
                                },
                            },
                        },
                    },
                    collection: activeProductCollection,
                    onChangeValue: function (view, model) {
                        if (lodash.isUndefined(model)) {
                            return;
                        }

                        var action = model.get('action');
                    },
                    behaviors: {
                        setDropdownValueToCurrentProduct: {
                            behaviorClass: Mn.Behavior.extend({
                                onBeforeRender: function () {
                                    this.listenTo(this.view, 'before:render:collection', function () {
                                        this.view.value = this.view.collection.findWhere({
                                            name: config.get('cayuse.apps.switcher.active.name'),
                                        });
                                    });
                                },
                            }),
                        },
                    },
                };
            },
        },

        _addRSHomeModelTo: function() {
          var activeProductCollection = Radio.request('AppKit.resourceService', 'resource', 'activeProductCollection');
          var npProductCollection = Radio.request('AppKit.resourceService', 'resource', 'nonProvisionableProductCollection');
          var rsHomeModel = npProductCollection.findWhere({name: 'RESEARCH_SUITE_HOME'});

          activeProductCollection.add(rsHomeModel, {at: 0});
        },

        onFirstBeforeRender: function() {
          this._addRSHomeModelTo();
        },

        initialize: function () {
            //prettier-ignore
            var personPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'personPrincipalModel'),
                self = this;
            UIKit.Menu.prototype.initialize.apply(this, arguments);

            this.appLogoView = this.buildComponent({name: 'appLogoView'});
            this.add(this.appLogoView);
            this.appsDropdownView = this.buildComponent({name: 'appsDropdownView'});
            this.add(this.appsDropdownView, {
                rightAligned: true,
            });
            this.userDropdownView = this.buildComponent({name: 'userDropdownView'});
            this.add(this.userDropdownView, {
                rightAligned: true,
            });

            var updateProfileInUserDropdown = function () {
                // If the personPrincipalModel has triggered a change event, it means a person linked
                // to the current user exists, and the personPrincipalModel has been set to that person.
                // If that is the case, we need to add a My Profile item to the dropdowns
                var _addProfileModelTo = function (collection) {
                    var npProductCollection = Radio.request(
                        'AppKit.resourceService',
                        'resource',
                        'nonProvisionableProductCollection'
                    );

                    // only add if there is a person with an id
                    if(personPrincipalModel.get('id')) {
                        var profileModel = npProductCollection.findWhere({name: 'PROFILE'});
                        if (profileModel && lodash.isEmpty(profileModel.get('thumbnail'))) {
                            //FIXME: When a proper icon image is proveded for Admin, we no longer need to set icon and unset thumbnail
                            profileModel.set({icon: 'user'});
                            profileModel.unset('thumbnail');
                        }
                        var existingModel = collection.findWhere({name: 'PROFILE'});
                        if (existingModel) {
                            var index = collection.indexOf(existingModel);
                            collection.remove(existingModel);
                            collection.add(profileModel, {at: index});
                        } else {
                            var index = collection.indexOf(userMenuDivider) + 1;
                            collection.add(profileModel, {at: index});
                        }
                    }
                };
                if (self.userDropdownView.isRendered) {
                    _addProfileModelTo(self.userDropdownView.collection);
                } else {
                    self.userDropdownView.on('first:render', function () {
                        _addProfileModelTo(self.userDropdownView.collection);
                    });
                }
            }

            if (config.get('cayuse.apps.switcher.include.profile')) {
                this.listenToOnce(personPrincipalModel, 'change:id', updateProfileInUserDropdown);
                this.listenToOnce(personPrincipalModel, 'change:user', updateProfileInUserDropdown);
            }

       },
    });

    module.exports = AppHeaderView;
});

